import React, { useState } from 'react';
import { Droppable } from '@hello-pangea/dnd';
import ChecklistItem from '../ChecklistItem';
import PlusIcon from '../icons/PlusIcon';
import {
    ChecklistContainer,
    ChecklistHeader,
    ChecklistTitle,
    Progress,
    ProgressBar,
    NewItemInput,
    Button,
    NewItemInputContainer,
    AddItemButton,
    ChecklistToggleButton
} from '../../styles/CardModal.styles';
import { calculateChecklistProgress } from '../../utils/cardUtils';
import ChevronIcon from '../icons/ChevronIcon';

const CardChecklists = ({
    cardData,
    setCardData,
    saveCardChanges,
    handleDeleteChecklist,
    handleAddChecklistItem,
    toggleChecklistItem,
    handleDeleteChecklistItem,
    handleUpdateChecklistItem,
    handleCreateSubtaskFromChecklistItem // Receive the new handler
}) => {
    const [newItemTexts, setNewItemTexts] = useState({});
    const [collapsedChecklists, setCollapsedChecklists] = useState({});

    const toggleChecklistCollapse = (checklistId) => {
        setCollapsedChecklists(prev => ({
            ...prev,
            [checklistId]: !prev[checklistId]
        }));
    };

    return (
        <>
            {cardData.checklists?.map(checklist => {
                const currentNewItemText = newItemTexts[checklist.id] || '';
                const isCollapsed = collapsedChecklists[checklist.id];

                return (
                    <ChecklistContainer key={checklist.id}>
                        <ChecklistHeader>
<ChecklistToggleButton onClick={() => toggleChecklistCollapse(checklist.id)} isExpanded={!isCollapsed}>
    <ChevronIcon direction={!isCollapsed ? 'down' : 'right'} />
</ChecklistToggleButton>
                            <ChecklistTitle
                                value={checklist.title}
                                onChange={e => {
                                    const updatedChecklists = cardData.checklists.map(cl =>
                                        cl.id === checklist.id ? { ...cl, title: e.target.value } : cl
                                    );
                                    setCardData(prev => ({ ...prev, checklists: updatedChecklists }));
                                }}
                                onBlur={() => saveCardChanges({ checklists: cardData.checklists })}
                            />
                            <Button onClick={() => handleDeleteChecklist(checklist.id)}>
                                Delete
                            </Button>
                        </ChecklistHeader>

                        {!isCollapsed && (
                            <>
                                <Progress>
                                    <ProgressBar percentage={calculateChecklistProgress(checklist)} />
                                </Progress>

                                <Droppable droppableId={`checklist-${checklist.id}`} type="CARD_CHECKLIST_ITEM">
                                    {(provided) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                        >
                                            {checklist.items?.map((item, index) => (
                                                <ChecklistItem
                                                    key={item.id}
                                                    item={item}
                                                    index={index}
                                                    onToggle={() => toggleChecklistItem(checklist.id, item.id)}
                                                    onDelete={() => handleDeleteChecklistItem(checklist.id, item.id)}
                                                    onUpdate={(newText) => handleUpdateChecklistItem(checklist.id, item.id, newText)}
                                                    handleCreateSubtaskFromChecklistItem={handleCreateSubtaskFromChecklistItem} // Pass down
                                                />
                                            ))}
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Droppable>

                                <NewItemInputContainer>
                                    <NewItemInput
                                        placeholder="Add an item"
                                        value={currentNewItemText}
                                        onChange={e => setNewItemTexts(prev => ({ ...prev, [checklist.id]: e.target.value }))}
                                        onKeyPress={e => {
                                            if (e.key === 'Enter' && currentNewItemText.trim()) {
                                                handleAddChecklistItem(checklist.id, currentNewItemText);
                                                setNewItemTexts(prev => ({ ...prev, [checklist.id]: '' }));
                                            }
                                        }}
                                    />
                                    <AddItemButton
                                        onClick={() => {
                                            if (currentNewItemText.trim()) {
                                                handleAddChecklistItem(checklist.id, currentNewItemText);
                                                setNewItemTexts(prev => ({ ...prev, [checklist.id]: '' }));
                                            }
                                        }}
                                        aria-label="Add item"
                                    >
                                        <PlusIcon />
                                    </AddItemButton>
                                </NewItemInputContainer>
                            </>
                        )}
                    </ChecklistContainer>
                )
            })}
        </>
    );
};

export default CardChecklists;